import * as amplitude from '@amplitude/analytics-browser';
import { AffiliationRole } from './constants';
import { capturePosthogEvent } from './posthog';

type PageViewedParams = {
    pageName: string;
    organizationId: number | null;
    spotId: number | null;
    affiliationRole: AffiliationRole | null;
    superuser: boolean | null;
    [index: string]: unknown;
};

export function trackEvent(event: string, data?: { [index: string]: unknown }): void {
    try {
        if (data === undefined) {
            amplitude.track(event);
        } else {
            amplitude.track(event, data);
        }
    } catch (error) {
        console.warn('Failed to track Amplitude event', error);
    }

    try {
        capturePosthogEvent(event, data ?? {});
    } catch (error) {
        console.warn('Failed to track PostHog event', error);
    }
}

export function trackPageViewed({ pageName, organizationId, spotId, ...rest }: PageViewedParams): void {
    const event = `Viewed ${pageName} Page`;
    setTimeout(() => trackEvent(event, { organizationId, spotId, ...rest }), 0);
}
